var map = {
	"./Home": [
		6865,
		679,
		865
	],
	"./Home/": [
		6865,
		679,
		865
	],
	"./Home/index": [
		6865,
		679,
		865
	],
	"./Home/index.tsx": [
		6865,
		679,
		865
	],
	"./Privacy": [
		2772,
		772
	],
	"./Privacy/": [
		2772,
		772
	],
	"./Privacy/index": [
		2772,
		772
	],
	"./Privacy/index.tsx": [
		2772,
		772
	],
	"./Terms": [
		3578,
		578
	],
	"./Terms/": [
		3578,
		578
	],
	"./Terms/index": [
		3578,
		578
	],
	"./Terms/index.tsx": [
		3578,
		578
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 717;
module.exports = webpackAsyncContext;